"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverOptions = void 0;
var tippy_js_1 = require("tippy.js");
var PopoverOptions = /** @class */ (function () {
    function PopoverOptions() {
    }
    return PopoverOptions;
}());
exports.PopoverOptions = PopoverOptions;
var Popover = /** @class */ (function () {
    function Popover(documentObject, options, element) {
        this.documentObject = documentObject;
        if (element) {
            this.initPopover(element, options);
        }
        else {
            this.initAllPopovers(documentObject, options);
        }
    }
    Popover.prototype.getOptionsFromDataset = function (element) {
        var options = new PopoverOptions();
        options.backgroundColor = element.dataset.popoverBackgroundColor ? element.dataset.popoverBackgroundColor : 'undefined';
        options.showOnHover = element.dataset.popoverShowOnHover ? JSON.parse(element.dataset.popoverShowOnHover) : false;
        options.showOnElementClick = element.dataset.popoverShowOnElementClick ? JSON.parse(element.dataset.popoverShowOnElementClick) : false;
        options.placement = element.dataset.popoverPlacement;
        options.content = element.dataset.popoverContent;
        options.hideOnClick = element.dataset.popoverHideOnClick !== "false";
        return options;
    };
    Popover.prototype.initAllPopovers = function (documentObject, options) {
        var popoverElements = documentObject.querySelectorAll('.js-popover');
        for (var i = 0; i < popoverElements.length; i++) {
            var popoverElement = popoverElements[i];
            this.initPopover(popoverElement, options);
        }
    };
    Popover.prototype.initPopover = function (element, options) {
        options = options !== null && options !== void 0 ? options : this.getOptionsFromDataset(element);
        (0, tippy_js_1.default)(element, {
            content: options.content,
            hideOnClick: options.showOnElementClick ? 'toggle' : options.hideOnClick,
            showOnCreate: options.showOnHover || options.showOnElementClick ? false : true,
            trigger: options.showOnHover ? 'mouseenter' : (options.showOnElementClick ? 'click' : 'manual'),
            theme: options.backgroundColor,
            placement: (options.placement ? options.placement : 'top'),
            onHide: function () {
                if (options.onHide) {
                    options.onHide();
                }
                else {
                    var event = document.createEvent('Event');
                    // Define that the event name is 'hide'.
                    event.initEvent('hidePopover', true, true);
                    element.dispatchEvent(event);
                }
            },
        });
    };
    return Popover;
}());
exports.default = Popover;
